/**
 * Performs a real (full-page) browser navigation.
 *
 * jsdom 26 makes `window.location` and all of its members "unforgeable" (matching the real DOM
 * spec), so it cannot be spied on or swapped out in tests to assert the exact URL — the best a test
 * can otherwise do is assert on jsdom's own "Not implemented: navigation" console error, which is
 * brittle (it couples the test to jsdom's diagnostic wording and can't verify *which* URL was set).
 * Routing every real navigation through this one function lets tests mock the module instead and
 * assert on the exact URL passed, without introducing a new dependency.
 */
export function navigateTo(url: string, options?: { replace?: boolean }): void {
	if (options?.replace) {
		window.location.replace(url);
	} else {
		window.location.href = url;
	}
}
